import { AxiosError } from 'axios';
import { GET_COORDINATOR_APPEAL_SUMMARY_URL } from '../../constants/apiUrls';
import { GET_COORDINATOR_APPEAL_SUMMARY_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface ApplicationStatus {
  applicationId: string;
  status: string;
  applicationDateTime: string;
  coordinatorName: string;
}

export interface CandidateDetails {
  statutoryName: string;
  nricFin: string;
  citizenship: string;
  schoolName: string;
  indexNo: string;
}

export interface SubjectInfoObject {
  nameDescription: string;
  nameCode: string;
  gradeAlphabetical: string;
  gradeNumerical: string;
  languageMedium: string;
  appealFee: string;
}

export interface SelectedSubjects {
  examYear: string;
  examLevel: string;
  examSeries: string;
  subjectInfo: SubjectInfoObject[];
}

export interface AppealFees {
  gstRegNo: string;
  totalGst: string;
  totalPayable: string;
  gstAbsorbed: string;
  totalPayableFeeExcludingGST: string;
  totalPayableFeeIncludingGST: string;
}

export interface TransactionDetails {
  transactionNumber: string;
  paymentTimeStamp: string;
  paymentMethod: string;
  totalFee: string;
  internalTransactionRef: string;
  gstRegNo: string;
  paymentStatus: string;
  paymentLinkRequired: boolean;
  registrationUuid: string;
}

export interface AppealOutcomeDownloadModel {
  fileName: string;
  fileKey: string;
}

export interface CoordinatorAppealSummaryResponse {
  applicationOutcome: AppealOutcomeDownloadModel;
  applicationStatus: ApplicationStatus;
  candidateDetails: CandidateDetails;
  selectedSubjects: SelectedSubjects;
  appealFees: AppealFees;
  transactionDetails: TransactionDetails;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const useGetCoordinatorAppealSummary = ({ onSuccess, onError, uuid }: Input) => {
  const getCoordinatorAppealSummary = async () => {
    const res = await axiosClient.get<CoordinatorAppealSummaryResponse>(
      GET_COORDINATOR_APPEAL_SUMMARY_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_COORDINATOR_APPEAL_SUMMARY_QUERY_KEY, getCoordinatorAppealSummary, {
    onSuccess,
    onError,
  });
};
